export default __webpack_public_path__ + "stroke-none.asset.639f6718949a2138f5dff8abedc48316.svg";